import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { Router } from '@angular/router';
import { isSupportedLanguage } from '../services/translation.service';
import { localizedURL } from '../helpers/navigation.helper';
import { StorageService } from '../services/storage.service';

export const nonAuthGuard = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const storageService = inject(StorageService);

  if (!tokenService.hasTokens()) {
    return true;
  }

  const savedLang = storageService.getLanguage(true);
  const lang = savedLang && isSupportedLanguage(savedLang) ? savedLang : 'en';
  const playareaUrl = localizedURL('/playarea', lang);

  // console.log('🌐 Redirecting to playarea page with language:', lang, playareaUrl);

  // If user is authenticated, redirect to games list
  router.navigate([playareaUrl]);
  return false;
};
